<template>
  <section>
    <v-row>
      <v-col>
        <h4 class="pl-2">{{$_strings.order.QUANTITY_INFO}}</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pa-1">
        <v-data-table
          :headers="displayedHeaders"
          calculate-widths
          hide-default-footer
          :items="items"
          class="grey lighten-4"
          :items-per-page="100"
        >
          <template v-slot:[`item.calculation`]={item}>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-badge
                  color="red"
                  content="!"
                  overlap
                  v-if="showWarning(item)"
                >
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="grey"
                  small
                  icon
                  :disabled="disableBtnCalculate(item)"
                  @click="showDialogChangeQty(item)"
                >
                  <v-icon>
                    mdi-autorenew
                  </v-icon>
                </v-btn>
                </v-badge>
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  color="grey"
                  small
                  icon
                  :disabled="disableBtnCalculate(item)"
                  @click="showDialogChangeQty(item)"
                  v-if="!showWarning(item)"
                >
                  <v-icon>
                    mdi-autorenew
                  </v-icon>
                </v-btn>
              </template>
              <span>{{$_strings.order.CALCULATE_QTY}}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.action`]={item}>
            <v-btn
              v-if="showBtnCalculationProcess(item)"
              @click="calculationProcess"
              small
              color="primary"
            >
              {{$_strings.order.CALCULATION_PROCESS}}
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DialogChangeQuantity
      ref='dialogChangeQuantity'
      @handleAfterChangeQty="handleAfterChangeQty"
      :isDelivery="$route.params.status === 'process'"
    />
  </section>
</template>

<script>
import { dateFormat, timeFormat } from '../../../helper/commonHelpers';
import RenderFunction from './function';
import DialogChangeQuantity from '../Dialog/ChangeQuantity.vue';

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    DialogChangeQuantity,
  },
  computed: {
    myUserInfo() {
      return this.$store.state.user.myUserInfo;
    },
    displayedHeaders() {
      const { status } = this.$route.params;
      const renderFunction = new RenderFunction(this);
      return renderFunction.tableHeader('qty').filter((t) => {
        if (status === 'process' && t.value === 'action') return;
        return t;
      });
    },
    items() {
      const { index, shipmentNumber, serviceType } = this.item;
      return this.item.subOrder.shipmentResponse.map((i) => (
        {
          id: i.id,
          indexShipment: index,
          shipmentNumber,
          orderNumber: i.orderNumber,
          cubic: i.cubic,
          tonnage: i.tonnage,
          carton: i.carton,
          isCalculated: i.isCalculated,
          orderStatus: i.orderStatus,
          serviceType,
        }
      ));
    },
  },
  methods: {
    dateFormat,
    timeFormat,
    showBtnCalculationProcess(item) {
      const canUpdate = this.$route.params.status === 'process' ? this.menuFunctions.INPUT_QTY_DALAM_PROSES : this.menuFunctions.INPUT_QTY_SELESAI;
      const status = ['terkonfirmasi', 'kedaluwarsa', 'dibatalkan', 'menunggu konfirmasi', 'menunggu konfirmasi transporter', 'menunggu konfirmasi driver'];
      if (canUpdate && !item.isCalculated && !status.includes(item.orderStatus.toLowerCase())) return true;
      return false;
    },
    disableBtnCalculate(item) {
      // const isCalculated = typeof item.carton === 'number' || typeof item.cubic === 'number' || typeof item.tonnage === 'number';
      const canUpdate = this.$route.params.status === 'process' ? this.menuFunctions.INPUT_QTY_DALAM_PROSES : this.menuFunctions.INPUT_QTY_SELESAI;
      const status = [
        'pesanan dibuat',
        'terkonfirmasi',
        'kedaluwarsa',
        'dibatalkan',
        'menunggu konfirmasi',
        'menunggu konfirmasi transporter',
        'menunggu konfirmasi driver',
      ];
      if (!canUpdate
        || status.includes(item.orderStatus.toLowerCase())
        // || item.isCalculated
        // || isCalculated
      ) return true;
      return false;
    },
    showDialogChangeQty(item) {
      this.$refs.dialogChangeQuantity.orderSelected = item;
      this.$refs.dialogChangeQuantity.dialog = true;
    },
    handleAfterChangeQty() {
      this.$delete(this.item, 'subOrder');
      this.$emit('fetchSubOrder', this.item);
    },
    calculationProcess() {
      this.$emit('viewDetailOrder', this.item);
    },
    showWarning(item) {
      const routeStatus = this.$route.params.status.toUpperCase();
      const statusIncomplete = ['kedaluwarsa', 'dibatalkan', 'waktu habis'];
      return routeStatus === 'FINISHED'
      && !statusIncomplete.includes(item.orderStatus.toLowerCase())
      && this.menuFunctions.HITUNG_BIAYA
      && !(typeof item.tonnage === 'number'
      || typeof item.carton === 'number'
      || typeof item.cubic === 'number');
    },
  },
};
</script>
